import React, { useState } from 'react';
import { Input } from '../../components/input/input.index';
import { Button } from '../../components/button/button.index';
import { ReduxState } from '../../../interfaces';
import { connect, ConnectedProps } from 'react-redux';
import { toast } from 'react-toastify';
import { setNewPassword } from 'services';
import { faNumToEnNum } from '../../../scripts';

const SetPassword: React.FC<ConnectedProps<typeof connector> & { onComplete: () => void }> = function (
    props: ConnectedProps<typeof connector> & { onComplete: () => void },
) {
    const [password, setPassword] = useState<string>('');
    const [repeatPassword, setRepeatPassword] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    const handleSetPassword = () => {
        const onComplete = () => {
            props.onComplete();
        };

        if (password === repeatPassword) {
            setNewPassword(setLoading, { password, repeatPassword }, onComplete);
        } else {
            toast.error('رمز عبور های وارد شده یکسان نیستند.');
        }
    };

    return (
        <div className={'flex flex-col w-full'}>
            <p className={'text-base text-darkPurple-100 mt-6 font-light max-lg:text-sm'}>
                رمز عبور جدید خود را تنظیم نمایید.
            </p>
            <Input
                type={'password'}
                className={'mt-6'}
                placeholder={'رمز عبور'}
                value={password}
                dir={password ? 'ltr' : 'rtl'}
                onChange={(e) => setPassword(faNumToEnNum(e.target.value))}
            />
            <Input
                type={'password'}
                className={'mt-4'}
                placeholder={'تکرار رمز عبور'}
                value={repeatPassword}
                dir={repeatPassword ? 'ltr' : 'rtl'}
                onChange={(e) => setRepeatPassword(faNumToEnNum(e.target.value))}
            />
            <ul className={'mt-4 text-xs font-medium flex flex-col gap-1'}>
                <li className={'flex items-center gap-2'}>
                    <div className={'w-1 h-1 rounded-full bg-black-100'} />
                    رمز عبور با ۸ کارکتر یا بیشتر باشد.
                </li>
                <li className={'flex items-center gap-2'}>
                    <div className={'w-1 h-1 rounded-full bg-black-100'} />
                    استفاده از حروف بزرگ
                </li>
                <li className={'flex items-center gap-2'}>
                    <div className={'w-1 h-1 rounded-full bg-black-100'} />
                    استفاده از عدد
                </li>
                <li className={'flex items-center gap-2'}>
                    <div className={'w-1 h-1 rounded-full bg-black-100'} />
                    استفاده از کارکتر‌های خاص : &، % ، $ ، @
                </li>
            </ul>
            <Button
                className={'mt-6'}
                type={'primary'}
                onClick={handleSetPassword}
                disabled={loading || !password || !repeatPassword}
            >
                تایید
            </Button>
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    isAuth: state.authStatus,
    user: state.userData,
});

const connector = connect(mapStateToProps);
export default connector(SetPassword);
